module.exports = __webpack_public_path__ + "static/options-01edf4617cc0c8c2d2c62d31a6234620.png";